"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(props, isOpen, inputValueAsPercentage) {
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    themeColors = _useContext.themeColors;
  var _ref = props,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    _ref$view = _ref.view,
    view = _ref$view === void 0 ? 'underline' : _ref$view,
    _ref$isWithClearButto = _ref.isWithClearButton,
    isWithClearButton = _ref$isWithClearButto === void 0 ? false : _ref$isWithClearButto,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$borderRadius = _ref.borderRadius,
    borderRadius = _ref$borderRadius === void 0 ? {} : _ref$borderRadius;
  var _props$type = props.type,
    type = _props$type === void 0 ? 'text' : _props$type,
    _props$width = props.width,
    width = _props$width === void 0 ? '100%' : _props$width;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem,
    getMeasurement = _useStylesUtils.getMeasurement,
    maskProps = _useStylesUtils.maskProps,
    fontSizeProps = _useStylesUtils.fontSizeProps,
    setEndDirection = _useStylesUtils.setEndDirection,
    borderRadiusProps = _useStylesUtils.borderRadiusProps;
  var ccInputStyle = (0, _react.useMemo)(function () {
    var viewProps = function viewProps() {
      if (view === 'underline') {
        return {
          borderBottom: "1px solid ".concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border),
          '&:focus': {
            borderBottom: "1px solid ".concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main)
          }
        };
      } else {
        return {};
      }
    };
    var rangeProps = function rangeProps() {
      return {
        background: "linear-gradient(90deg, ".concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main, " 0%, ").concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main, " ").concat(inputValueAsPercentage, "%, rgba(112, 112, 112, 0.45) ").concat(inputValueAsPercentage, "%, rgba(112, 112, 112, 0.45) 100%)")
      };
    };
    var sliderDeviceProps = function sliderDeviceProps() {
      var height = isMobileView ? pxToRem(6) : pxToRem(2);
      return {
        height: height
      };
    };
    var typeProps = function typeProps() {
      switch (type) {
        case 'text':
          return _objectSpread(_objectSpread({
            backgroundColor: 'transparent',
            overflow: 'hidden',
            outline: 'none',
            height: pxToRem(24),
            border: 0
          }, fontSizeProps(size)), viewProps());
        case 'range':
          return _objectSpread(_objectSpread(_objectSpread({
            appearance: 'none',
            borderRadius: pxToRem(3),
            background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border,
            outline: 'none',
            transition: 'opacity 0.2s',
            direction: 'ltr',
            margin: "".concat(pxToRem(23), " 0")
          }, rangeProps()), sliderDeviceProps()), {}, {
            '&::-webkit-slider-thumb': {
              appearance: 'none',
              width: pxToRem(20),
              height: pxToRem(20),
              background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main,
              borderRadius: '50%',
              cursor: 'pointer'
            }
          });
        default:
          return {};
      }
    };
    var clearProps = function clearProps() {
      var paddingInlineEnd = isWithClearButton ? pxToRem(15) : 0;
      return {
        paddingInlineEnd: paddingInlineEnd
      };
    };
    var borderProps = function borderProps() {
      if (Object.keys(borderRadius).length !== 0) {
        return _objectSpread(_objectSpread({
          border: "1px solid ".concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border)
        }, borderRadiusProps(borderRadius)), {}, {
          padding: "".concat(pxToRem(8), " ").concat(pxToRem(12))
        });
      }
      return {};
    };
    var disabledProps = function disabledProps() {
      if (isDisabled) {
        return {
          opacity: '.5',
          cursor: 'default'
        };
      }
      return {};
    };
    var ccInputMask = (0, _css.css)(_objectSpread({}, maskProps(isOpen)));
    var ccInput = (0, _css.css)(_objectSpread(_objectSpread({
      position: 'relative',
      userSelect: 'none',
      width: '100%'
    }, disabledProps()), borderProps()));
    var ccInputContent = (0, _css.css)({
      position: 'relative',
      width: '100%'
    });
    var ccInputField = (0, _css.css)(_objectSpread(_objectSpread({
      fontFamily: fontFamily,
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text,
      width: getMeasurement(width)
    }, typeProps()), clearProps()));
    var ccInputClearBtn = (0, _css.css)(_objectSpread({
      display: 'flex',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      height: pxToRem(10)
    }, setEndDirection(0)));
    return {
      ccInputMask: ccInputMask,
      ccInput: ccInput,
      ccInputContent: ccInputContent,
      ccInputField: ccInputField,
      ccInputClearBtn: ccInputClearBtn
    };
  }, [maskProps, isOpen, fontFamily, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.border, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main, getMeasurement, width, pxToRem, setEndDirection, view, inputValueAsPercentage, isMobileView, type, fontSizeProps, size, isWithClearButton, borderRadius, borderRadiusProps, isDisabled]);
  return {
    'cc-Input-mask': ccInputStyle.ccInputMask,
    'cc-Input': ccInputStyle.ccInput,
    'cc-Input__content': ccInputStyle.ccInputContent,
    'cc-Input__field': ccInputStyle.ccInputField,
    'cc-Input__clear-btn': ccInputStyle.ccInputClearBtn
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;